import React, { Component } from "react";
import {
  Card,
  Button,
  Select,
  Input,
  Table,
  Modal,
  DatePicker,
  message,
} from "antd";
import moment from "moment";

import { connect } from "react-redux";
import { req_page_questionLog, req_add_consulting } from "../../api";

import { usrRole } from "../../utils/dataUtil";
import { formateDate, formateDatetimestamp } from "../../utils/dateUtil";
import {
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";

import OneQuestionRepliesModal from "./one-question-replies-modal";
import ConsultingAdd from "./consulting-add";

class Questionlog extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    items: [],
    item: {}, // selected
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    userLevel: "NORMAL",
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "None",
    searchValue: "",
    filterStatus: "DATELIMIT",
    loading: false,
    isShowModal_reply_items: false,
    isShowModal_add_item: false,
    dateLimitZone: formateDatetimestamp(
      new Date().setDate(new Date().getDate() - 7)
    ),
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    this.api_page_items(1);
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_page_items = async (current) => {
    this.current = current; // 保存當前頁，給其他方法可看到
    const { pageSize } = this.state.pagination;
    const { searchField, searchValue, columnSort, orderBy, dateLimitZone } =
      this.state;
    const { token, role, userCode } = this.props.user;

    const userLevel = usrRole(role);
    this.setState({ loading: true, userLevel: userLevel });
    const result = await req_page_questionLog(
      userLevel,
      userCode,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      dateLimitZone,
      token
    );
    this.setState({ loading: false });
    //console.log(result)
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination });
      //console.log(this.state);
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination });
    }
  };

  api_add_item = async (row) => {
    const token = this.props.user.token;
    //console.log(row)
    const result = await req_add_consulting(row, token);
    if (result.status === "success") {
      // 1 結果提示
      message.success("新增成功");
      this.setState({ isShowModal_add_item: false });
      this.api_page_items(1);
    } else {
      console.log(result);
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  isPrcess = (hasTag, id) => {
    return hasTag === "W" ? (
      <Button
        type="dashed"
        size="small"
        style={{ color: "Red", marginRight: "4px" }}
        onClick={() => this.handle_show_ui_add_item(id)}
      >
        <i className="fas fa-question" style={{ marginRight: "4px" }}></i>{" "}
        待定義
      </Button>
    ) : (
      "已定義"
    );
  };

  init_columns = () => {
    this.columns = [
      {
        title: "流水號",
        dataIndex: "id",
        width: 20,
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "提問問題",
        dataIndex: "questionContent",
        width: 120,
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "發問IP",
        dataIndex: "recordIPAddress",
        width: 50,
        responsive: ["md"],
      },
      {
        title: "發問時間",
        dataIndex: "recordCreateDatetime",
        width: 40,
        responsive: ["md"],
        render: (RecordCreateDateTime) => formateDate(RecordCreateDateTime),
      },
      {
        title: "操作",
        width: 40,
        fixed: "right",
        render: (item) => {
          const { numberOfFeedback, hasTag, id } = item;
          return (
            <>
              {numberOfFeedback > 0 ? (
                <Button
                  type="dashed"
                  size="small"
                  style={{ color: "DarkGreen" }}
                  onClick={() => this.handle_show_ui_reply_item(item)}
                >
                  <i
                    className="fas fa-comment-dots"
                    style={{ marginRight: "4px" }}
                  ></i>{" "}
                  答覆 {numberOfFeedback} 則
                </Button>
              ) : (
                this.isPrcess(hasTag, id)
              )}
            </>
          );
        },
      },
    ];
  };

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_pick_date = (date, dateString) => {
    //console.log(dateString)
    this.setState({ dateLimitZone: dateString });
  };

  // 操作互動處理 //////////////////////////////////////////////

  handle_show_ui_reply_item = (item) => {
    //console.log(applycase)
    this.setState({ isShowModal_reply_items: true, item });
  };

  // 增加
  handle_show_ui_add_item = (id) => {
    const { userName, userCode } = this.props.user;
    const item = {
      id: id,
      serviceTitle: "",
      serviceDescription: "無",
      serviceDepartment: "",
      serviceStaffName: userName,
      serviceTelephone: "",
      handlingTime: "即收即辦當日完成",
      nGoogleLocation: "0",
      applicableObjects: "所有對象",
      limitScope: "",
      recordCreator: userCode,
    };
    //console.log(item)
    this.setState({ isShowModal_add_item: true, item });
  };

  handle_add_save_item = () => {
    const { id, recordCreator } = this.state.item;
    this.modal_form_add_item.current
      .validateFields()
      .then((values) => {
        const {
          serviceTitle,
          serviceDescription,
          serviceDepartment,
          serviceStaffName,
          serviceTelephone,
          handlingTime,
          applicableObjects,
        } = values;
        let item = {
          id: id,
          serviceTitle: serviceTitle,
          serviceDescription: serviceDescription,
          serviceDepartment: serviceDepartment,
          serviceStaffName: serviceStaffName,
          serviceTelephone: serviceTelephone,
          handlingTime: handlingTime,
          applicableObjects: applicableObjects,
          isHiding: "N",
          isDefine: "N",
          recordCreator: recordCreator,
        };
        this.api_add_item(item);
      })
      .catch((error) => {
        //console.log(error.errorFields);
      });
  };
  /////////////////////////////////////////////////////////////
  render() {
    const {
      loading,
      item,
      items,
      pagination,
      searchField,
      searchValue,
      isShowModal_reply_items,
      isShowModal_add_item,
      dateLimitZone,
    } = this.state;
    const title = (
      <>
        <DatePicker
          onChange={this.handle_pick_date}
          defaultValue={moment(dateLimitZone, "YYYY-MM-DD")}
        />
        <Select
          value={searchField}
          style={{ width: 120 }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="None">搜索條件</Select.Option>
          <Select.Option value="questionContent">問題內容</Select.Option>
          <Select.Option value="numberOfFeedback">回覆項數</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{ width: 150, margin: "0 5px" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Button type="primary" onClick={() => this.api_page_items(1)}>
          <i className="fas fa-search" style={{ marginRight: "4px" }}></i>查詢
        </Button>
      </>
    );
    return (
      <Card title={title}>
        <Table
          bordered
          scroll={{ y: 600 }}
          loading={loading}
          rowKey="gid"
          dataSource={items}
          onChange={this.handle_table_change}
          pagination={{
            ...pagination,
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            // onChange: this.api_page_applycase,
            onShowSizeChange: this.handle_page_size_change,
          }}
          columns={this.columns}
        />
        <Modal
          destroyOnClose={true}
          title="回覆清單"
          visible={isShowModal_reply_items}
          onOk={() => {
            this.setState({ isShowModal_reply_items: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <OneQuestionRepliesModal item={item} />
        </Modal>
        <Modal
          destroyOnClose={true}
          title="增加諮詢項目"
          visible={isShowModal_add_item}
          onOk={this.handle_add_save_item}
          onCancel={() => {
            this.setState({ isShowModal_add_item: false });
          }}
        >
          <ConsultingAdd
            modalform={(form) => (this.modal_form_add_item = form)}
            item={item}
          />
        </Modal>
      </Card>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(Questionlog);
